import React, { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import { useGetProduct, useUpdateProducts, useInsertProducts } from '../../hooks/groups/Products';
import GroupProductsTextInput from './GroupProductsTextInput';
import { setObjectValue, validate } from '../../helpers/general';
import ImageUploader from '../global/ImageUploader';
import ImageWithFallback from "../global/ImageWithFallback";
import emptyAvatar from "../../assets/img/empty_avatar.png";
import LoadingSpinner from '../global/LoadingSpinner';
import { useGetVendorId } from '../../hooks/global/User';
import SweetAlert from "sweetalert-react";import { useGetAvailableLanguages } from '../../hooks/global/Languages';
;

function GroupProductsEditForm({ id, moduleId,  onClose }) {
    const { t } = useTranslation();
    const { data: productData, isLoading, isError, refetch } = useGetProduct(id);
    const [previewUrl, setPreviewUrl] = useState();
    const { mutateAsync:update, data: updateData, isLoading:isUpdateLoading, isError:isUpdateError, } = useUpdateProducts(id, moduleId);
    const { mutateAsync:insert, data: insertedData, isLoading:isInsertedLoading, isError:isInsertedError } = useInsertProducts( moduleId );
    const [ showAddImage , setShowAddImage ] = useState(false);
    const [ error, setError ] = useState(false);
    const [ errorText, setErrorText ] = useState('');
    const availableLan = useGetAvailableLanguages();

    const vendorId = useGetVendorId();

    const [ validateData, setValidateData ] = useState({});

    let validateRules = availableLan.map((lng) => { return { index: 'name.'+lng, regex: /^.+$/s, condition: true } });
    validateRules.push({ index: 'code', regex: /^.+$/s, condition: true });


    useEffect(() => {
        refetch()
    },[]);

    useEffect(() => {
        if(insertedData || updateData) {
            setError(insertedData?.error || updateData?.error );
            setErrorText(insertedData?.type || updateData?.type);
        };
    },[id, insertedData, updateData]);

    const handleUpdate = (e) => {
        setObjectValue(productData, e.index, e.data);
        if( e.index === "img_url" ) {
            setPreviewUrl(e.data);
        }
    };

    const handleSave = () =>{
        const validatorErrors = validate(productData, validateRules);
        setValidateData(validatorErrors);


        (previewUrl) && setObjectValue(productData, "img_url", previewUrl);

        if(validatorErrors.e) return;

        (id && productData.id) ? 
        update({data:productData, message: `${t('toast.crPr1')} ${t('toast.crPr2b')} ${t('toast.crPr3')}` }).then((res) => {(!res?.error) && onClose?.();}) 
        : insert({data:productData, message:`${t('toast.crPr1')} ${t('toast.crPr2a')} ${t('toast.crPr3')}`}).then((res) => {(!res?.error) && onClose?.();});
    }

    const handleSubmit = () => {
        handleSave();
        //onClose?.();
    }

    const handleClose = () => {
        onClose?.();
        refetch();
    }

    const handleStatus = (s) => {
        s === "DISABLED" || console.log("Show POPUP"); //TODO

        setObjectValue(productData, "status", s);
        onClose?.();
        handleSave();
    }
    if (isLoading) return <LoadingSpinner/>
    if (isError) return "Error...";


    return (
        <div className="productSingleForm">
            <div className={"modulElementNew"}>
                <div className="row">
                    <div className="col-md-9">
                        <div className="editMe-field">
                            <div className="inputWrapCustom inputWrapCustomDisabled">
                            {productData.source_id && (<>
                                <strong>{t("admin.group.elId")}</strong>
                                    <div>
                                        <input tabIndex="0"
                                            value={productData.source_id}
                                            disabled={true} />
                                    </div>
                                </>)}
                            </div>
                        </div>

                        <div className="editMe-field">
                            <strong>{t("admin.group.tiEl")}</strong>
                            <div>
                                <GroupProductsTextInput index="name" value={productData.name} onChange={handleUpdate} error = {validateData.e} validate={validateData.newValidateData} />
                            </div>

                        </div>
                        {"vendor.invoiceInviteSettings.enabled" && //TODO
                            <div className="editMe-field">
                                <div className="inputWrapCustom inputWrapCustomDisabled">
                                    <strong>{t("admin.group.elCode")}</strong>
                                    <div>
                                        <GroupProductsTextInput index="code" value={productData.code} onChange={handleUpdate} complex={false} error = {validateData.e} validate={validateData.newValidateData} />
                                    </div>
                                </div>
                            </div>
                        }

                        <div className="artImgUploader artImgUploaderElement">
                            <div className="editMe-field">
                                <div className="artImgCTA">
                                    <strong>{t("admin.group.elPic")}</strong>
                                    {showAddImage ? (
                                        <div className="artImgForm">
                                            <span className="closeMe" onClick={() => setShowAddImage(false)}>{t("admin.common.close")}</span>
                                            <ImageUploader index="img_url" location={`images/merlin/vendors/${vendorId}`} onSave={(e) => {handleUpdate(e); setShowAddImage(false)}}/>
                                        </div>
                                    ) : (
                                        <div>
                                            <button type="button" onClick={() => setShowAddImage(true)}>{t("admin.group.picUp")}</button>
                                        </div>
                                    )
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="productImgWrap">
                            <strong className="productImgWrapHelper">{t("admin.group.prev")}</strong>
                            {(productData.img_url || previewUrl)? (
                                <ImageWithFallback src={previewUrl? previewUrl:productData.img_url} alt={t("err.noUrl")}  className="productImg"/>
                            ) : (
                                <img className="productImg" alt="Empty Avatar" src={emptyAvatar} />
                            )
                            }
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <div>

                            <button type="button"
                                onClick={handleSubmit}
                                className="btn btn-default btn-save float-left"
                                title={t("admin.common.save")}
                                disabled={showAddImage}>{t("admin.common.save")}</button>
                            <button type="button"
                                className="btn btn-default btn-cancel float-left"
                                onClick={handleClose}
                                title="Prekliči">{t("admin.common.close")}</button>
                            {productData && productData.id && productData.status !== 'DISABLED' &&
                                <button type="button"
                                    className="btn btn-default btn-delete" style={{float: "right"}}
                                    onClick={() => handleStatus("DISABLED")}
                                    title="Deaktiviraj">{t("admin.group.deac")}</button>
                            }

                            {productData && productData.id && productData.status === 'DISABLED' &&
                                <button type="button"
                                    className="btn btn-default btn-save" style={{float: "right"}}
                                    onClick={() => (handleStatus("OK"))}
                                    title={t("admin.group.ac")}>{t("admin.group.ac")}</button>
                            }
                        </div>
                    </div>
                </div>
            </div>

            <SweetAlert
                    show={error}
                    title={t("err.edEl")}
					type="warning"
					text={t(errorText)}
					confirmButtonText="Ok"
					cancelButtonText={t("common.ca")}
                    onConfirm={() => setError(false)}
                />

        </div>
    );
};

export default GroupProductsEditForm;